import React, { useEffect, useState } from 'react';
import api from '../../api';

const SUPPayoutReport = ({ currentSupplier }) => {
    const [payouts, setPayouts] = useState([]);          // master list
    const [selectedPayoutID, setSelectedPayoutID] = useState(null);
    const [detail, setDetail] = useState(null);          // detail view
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('');

    // ------------------------------------------------------------
    // Load MASTER LIST of payouts
    // ------------------------------------------------------------
    useEffect(() => {
        const fetchPayouts = async () => {
            try {
                setLoading(true);
                const res = await api.get(`/supplierReport/payout/${currentSupplier.id}`);
                setPayouts(res.data || []);
                setStatus('');
            } catch (err) {
                console.error('Error fetching payout list:', err);
                setStatus('Error loading payout list.');
            } finally {
                setLoading(false);
            }
        };

        fetchPayouts();
    }, [currentSupplier.id]);

    // ------------------------------------------------------------
    // Load DETAIL for selected payout
    // ------------------------------------------------------------
    useEffect(() => {
        if (!selectedPayoutID) return;

        const fetchDetail = async () => {
            try {
                setLoading(true);
                const res = await api.get(`/supplierReport/payoutDetails/${selectedPayoutID}`);
                setDetail(res.data || null);
                setStatus('');
            } catch (err) {
                console.error('Error fetching payout detail:', err);
                setStatus('Error loading payout detail.');
            } finally {
                setLoading(false);
            }
        };

        fetchDetail();
    }, [selectedPayoutID]);
    function formatDate(dateString) {
    if (!dateString) return '-';

    const d = new Date(dateString);

    // Format: YYYY-MM-DD HH:mm
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

    return (
        <div className="supplier-payout-report">
            <h3>Supplier Payout Report</h3>

            {loading && <p>Loading�</p>}
            {status && <p className="status-message">{status}</p>}

            {/* ------------------------------------------------------------
                MASTER LIST VIEW
            ------------------------------------------------------------ */}
            {!loading && !selectedPayoutID && (
                <>
                    {payouts.length === 0 && <p>No payouts found.</p>}

                    {payouts.length > 0 && (
                        <table className="matrix-grid">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Stripe ID</th>
                                </tr>
                            </thead>

                            <tbody>
                                {payouts.map(p => (
                                    <tr
                                        key={p.payoutID}
                                        onClick={() => setSelectedPayoutID(p.payoutID)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td>{formatDate(p.paidDate || p.failedDate)}</td>
                                        <td>${Number(p.amountOwed).toFixed(2)}</td>
                                        <td>{p.payoutStatus}</td>
                                        <td>{p.paymentID}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </>
            )}

            {/* ------------------------------------------------------------
                DETAIL VIEW
            ------------------------------------------------------------ */}
            {!loading && selectedPayoutID && detail && (
                <>
                    <button onClick={() => setSelectedPayoutID(null)}>
                        Back to Payout List
                    </button>

                    <div className="payout-summary">
                        <p><strong>Payout Date:</strong> {detail.payout.paidDate}</p>
                        <p><strong>Amount Paid:</strong> ${Number(detail.payout.amountOwed).toFixed(2)}</p>
                        <p><strong>Stripe Transfer ID:</strong> {detail.payout.paymentID}</p>
                    </div>

                    <h4>Itemized Breakdown</h4>

                    <table className="matrix-grid">
                        <thead>
                            <tr>
                                <th>Variety</th>
                                <th>Units</th>
                            </tr>
                        </thead>

                        <tbody>
                            {detail.items.map((row, idx) => (
                                <tr key={idx}>
                                    <td>{row.supplierVariety}</td>
                                    <td>{row.totalUnits}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
};

export default SUPPayoutReport;
